import { render, staticRenderFns } from "./map-switch.vue?vue&type=template&id=277fe834&scoped=true&"
import script from "./map-switch.vue?vue&type=script&lang=js&"
export * from "./map-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277fe834",
  null
  
)

export default component.exports